
import React from 'react';
import { Link } from 'react-router-dom';
import { ImPointRight } from "react-icons/im";
import { CgFileDocument } from "react-icons/cg";
import {
  AiOutlineFundProjectionScreen,
  AiOutlineUser,

} from "react-icons/ai";


const HomeThree = () => {
  return (
    <div>
    <div style={styles.container}>
      <h1 style={styles.header}>LET ME <span className="purple"> INTRODUCE </span> MYSELF </h1>
      <p style={styles.paragraph}>
      I am a passionate and experienced software engineer specializing in <span className="purple"> front-end development with React </span>. Additionally, I have a strong foundation in <span className="purple"> C++ </span> and <span className="purple"> Python </span> , which I use for various programming and development tasks. My journey in the tech industry has equipped me with a diverse skill set that allows me to build robust and scalable applications, both on the client and server sides.
      </p>

      <h2 style={styles.subHeader}>My <span className="purple"> Skills </span></h2>
      <ul>
        <li style={styles.listItem}>
        <ImPointRight /><strong>  Front-End Development:</strong>
          <ul>
            <li><span className="purple"> React:</span> Expertise in building dynamic, high-performance web applications using React. Proficient in React Hooks, Redux for state management, and integrating with various APIs.</li>
            <li><span className="purple"> HTML/CSS/JavaScript: </span> Strong foundation in web development basics, ensuring semantic, accessible, and responsive design.</li>
          </ul>
        </li>
        <li style={styles.listItem}>
        <ImPointRight /> <strong> General Programming: </strong>
          <ul>
            <li><span className="purple"> C++: </span> Experience in developing high-performance applications, working on complex algorithms, and system-level programming.</li>
            <li><span className="purple"> Python: </span> Skilled in Python for backend services, data analysis, and automation. Familiar with frameworks like Django and Flask.</li>
          </ul>
        </li>
        <li style={styles.listItem}>
        <ImPointRight /> <strong>Tools & Technologies:</strong>
          <ul>
            <li><span className="purple"> Version Control: </span>  Proficient in using Git and GitHub for version control and collaboration.</li>
          </ul>
        </li>
      </ul>
      
      <div style={styles.navbar}>
       <Link className='btn btn-primary' to="/about" style={styles.link}><AiOutlineUser style={{ marginBottom: "2px" }} /> About Me</Link>
      <Link className='btn btn-primary' to="/project" style={styles.link}><AiOutlineFundProjectionScreen style={{ marginBottom: "2px" }}/> Projects</Link>
       <Link className='btn btn-primary' to="/resume" style={styles.link}><CgFileDocument style={{ marginBottom: "2px" }} /> Resume</Link>
      </div>
     
     

    </div>
    
    </div>
  );
};

const styles = {
  navbar: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px',
  },
  link: {
    margin: '0 15px',
    color: '#fff',
    textDecoration: 'none',
  },
  container: {
    fontFamily: 'Arial, sans-serif',
    margin: '0 auto',
    maxWidth: '800px',
    padding: '20px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  subHeader: {
    marginTop: '20px',
  },
  paragraph: {
    lineHeight: '1.6',
    textAlign: 'start',
  },
  listItem: {
    marginBottom: '10px',
    textAlign: 'start',
  },
};

export default HomeThree;
